export default __webpack_public_path__ + "static/graph-desktop-b318fc3ca5fbbe1b22dab0a4f21ba738.png";